var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecurringCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "#62686E",
  "aria-hidden": "true",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.25 0A.75.75 0 0 1 7 .75V4.5H5.5V.75A.75.75 0 0 1 6.25 0m12 0a.75.75 0 0 1 .75.75V4.5h-1.5V.75a.75.75 0 0 1 .75-.75m4.5 3H20.5V1.5h2.25a1.5 1.5 0 0 1 1.5 1.5v19.5a1.5 1.5 0 0 1-1.5 1.5h-21a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 1.5-1.5h10.94L9.47 8.78a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H1.75v9h21zM8.5 1.5H16V3H8.5zM4 1.5H1.75A1.5 1.5 0 0 0 .25 3v4.5h1.5V3H4z",
  clipRule: "evenodd"
})));
export default SvgRecurringCalendar;